import script from "./VideoSelectionView.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoSelectionView.vue?vue&type=script&lang=ts&setup=true"

import "./VideoSelectionView.vue?vue&type=style&index=0&id=a7182bec&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7182bec"]])

export default __exports__